/* eslint-disable import/prefer-default-export */
import { useIsMutating, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAlternatePaymentMethodRequest } from '@syf-api-library/alternate-payment-methods';
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import HTTPError from 'syf-js-utilities/typings/HTTPError';
import { paymentsCacheKey } from '../api/cacheKeys';
import { paymentsUrl } from '../api/endpoints';
const getTrackingHeaders = () => {
    return {
        'x-syf-request-trackingid': generateUUID()
    };
};
const getAuthHeaders = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    const correlationId = sessionStorage.getItem('correlationId');
    return {
        Authorization: `Bearer ${accessToken}`,
        'x-syf-request-correlationid': correlationId || ''
    };
};
export const getFormattedPayloadFromVariablesACH = (mutationVariables) => {
    const { id } = mutationVariables.paymentMethod;
    const alternatePaymentMethodRequest = getAlternatePaymentMethodRequest(id);
    if (alternatePaymentMethodRequest) {
        return alternatePaymentMethodRequest.paymentMethod;
    }
    return {
        id
    };
};
export const getFormattedPayloadFromVariablesCard = (mutationVariables) => {
    const { id } = mutationVariables.paymentCardInfo;
    const alternatePaymentMethodRequest = getAlternatePaymentMethodRequest(id);
    if (alternatePaymentMethodRequest) {
        return alternatePaymentMethodRequest.paymentCardInfo;
    }
    return {
        id
    };
};
export const usePaymentsMutation = ({ config, keyProps, mutationOptions = {} }) => {
    const fullUrl = new URL(paymentsUrl, config.hosts.apigee);
    const queryClient = useQueryClient();
    return useMutation(Object.assign(Object.assign({ mutationKey: paymentsCacheKey(keyProps), mutationFn: async (mutationVariables) => {
            const { amount, date, paymentMedium } = mutationVariables;
            const { accountId, accountIdType } = keyProps;
            const requestBody = Object.assign({ accountIdType,
                amount, 'cipher.accountId': accountId, date,
                paymentMedium }, (paymentMedium === 'E_CHECK'
                ? {
                    paymentMethod: getFormattedPayloadFromVariablesACH(mutationVariables)
                }
                : {
                    paymentCardInfo: getFormattedPayloadFromVariablesCard(mutationVariables)
                }));
            const response = await fetch(fullUrl.toString(), {
                mode: 'cors',
                headers: Object.assign(Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, getAuthHeaders()), getTrackingHeaders()),
                method: 'POST',
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                const err = new HTTPError(response);
                config.apiErrorCallback(err);
                throw err;
            }
            let body = {};
            try {
                body = await response.json();
            }
            catch (_a) {
                // noop
            }
            finally {
                body = body !== null && body !== void 0 ? body : {};
            }
            try {
                return {
                    status: response.status,
                    body: body
                };
            }
            catch (e) {
                throw new HTTPError(response);
            }
        } }, mutationOptions), { onSuccess: (data) => {
            queryClient.setQueryData(paymentsCacheKey(keyProps), data);
        } }));
};
export const useIsPaymentsMutating = ({ keyProps }) => {
    return useIsMutating(paymentsCacheKey(keyProps)) > 0;
};
